import { render, staticRenderFns } from "./DashboardCalendarItem.vue?vue&type=template&id=0201dc54"
import script from "./DashboardCalendarItem.vue?vue&type=script&lang=js"
export * from "./DashboardCalendarItem.vue?vue&type=script&lang=js"
import style0 from "./DashboardCalendarItem.vue?vue&type=style&index=0&id=0201dc54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports